import { ReactNode } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@heroui/popover';

interface PopoverContainerProps {
  trigger: ReactNode;
  content: ReactNode;
}

function PopoverContainer({ trigger, content }: PopoverContainerProps) {
  return (
    <Popover shouldCloseOnBlur placement="bottom-start">
      <PopoverTrigger className="px-3 min-w-14 h-14">
        {trigger}
      </PopoverTrigger>
      <PopoverContent className="text-foreground p-0 rounded-lg bg-default">
        {content}
      </PopoverContent>
    </Popover>
  );
}

export default PopoverContainer;
